
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/sandbox/test-credentials",
      function () {
        return require("private-next-pages/docs/sandbox/test-credentials.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/sandbox/test-credentials"])
      });
    }
  